"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Link = require("./Link");

var _Link2 = _interopRequireDefault(_Link);

var _NavTab = require("./NavTab");

var _NavTab2 = _interopRequireDefault(_NavTab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getProp = function getProp(listings, prop) {
  return listings && listings[0] && listings[0].allChildren && listings[0].allChildren.length === 1 && listings[0].allChildren[0] && listings[0].allChildren[0].data && listings[0].allChildren[0].data[prop];
};
var isCommentsPage = function isCommentsPage(listings) {
  return listings && listings[1];
};
var getPermalink = function getPermalink(listings) {
  return getProp(listings, "permalink");
};
var getDupesLink = function getDupesLink(listings) {
  return getPermalink(listings) && getPermalink(listings).replace("/comments/", "/duplicates/");
};

var HeaderBottomLeft = function HeaderBottomLeft(_ref) {
  var _ref$Link = _ref.Link,
      Link = _ref$Link === undefined ? _Link2.default : _ref$Link,
      _ref$NavTab = _ref.NavTab,
      NavTab = _ref$NavTab === undefined ? _NavTab2.default : _ref$NavTab,
      _ref$subreddit = _ref.subreddit,
      subreddit = _ref$subreddit === undefined ? "all" : _ref$subreddit,
      _ref$siteprefix = _ref.siteprefix,
      siteprefix = _ref$siteprefix === undefined ? "r" : _ref$siteprefix,
      subredditData = _ref.subredditData,
      useStyle = _ref.useStyle,
      listings = _ref.listings,
      numOtherDiscussions = _ref.numOtherDiscussions,
      props = _objectWithoutProperties(_ref, ["Link", "NavTab", "subreddit", "siteprefix", "subredditData", "useStyle", "listings", "numOtherDiscussions"]);

  return _react2.default.createElement(
    "div",
    { id: "header-bottom-left" },
    useStyle && subredditData && subredditData.header_img ? _react2.default.createElement(
      Link,
      { href: "/" },
      _react2.default.createElement("img", {
        id: "header-img",
        src: subredditData.header_img,
        alt: subredditData.display_name
      })
    ) : _react2.default.createElement(
      Link,
      {
        className: "default-header",
        href: "/",
        id: "header-img"
      },
      "snew"
    ),
    "\xA0",
    subreddit ? _react2.default.createElement(
      "span",
      { className: "hover pagename redditname" },
      _react2.default.createElement(
        Link,
        { href: "/" + siteprefix + "/" + subreddit + "/" },
        subreddit
      )
    ) : null,
    isCommentsPage(listings) ? _react2.default.createElement(
      "ul",
      { className: "tabmenu" },
      _react2.default.createElement(
        NavTab,
        _extends({ href: getPermalink(listings) }, _extends({ Link: Link }, props)),
        "comments"
      ),
      _react2.default.createElement(
        NavTab,
        _extends({ href: getDupesLink(listings) }, _extends({ Link: Link }, props)),
        "other discussions",
        numOtherDiscussions && "(" + numOtherDiscussions + ")"
      )
    ) : _react2.default.createElement(
      "ul",
      { className: "tabmenu" },
      _react2.default.createElement(
        NavTab,
        _extends({ href: subreddit ? "/" + siteprefix + "/" + subreddit + "/" : "/" }, { Link: Link }),
        "hot"
      ),
      _react2.default.createElement(
        NavTab,
        _extends({ href: subreddit ? "/" + siteprefix + "/" + subreddit + "/new/" : "/new/" }, { Link: Link }),
        "new"
      ),
      _react2.default.createElement(
        NavTab,
        _extends({ href: subreddit ? "/" + siteprefix + "/" + subreddit + "/rising/" : "/rising/" }, { Link: Link }),
        "rising"
      ),
      _react2.default.createElement(
        NavTab,
        _extends({ href: subreddit ? "/" + siteprefix + "/" + subreddit + "/controversial/" : "/controversial/" }, { Link: Link }),
        "controversial"
      ),
      _react2.default.createElement(
        NavTab,
        _extends({ href: subreddit ? "/" + siteprefix + "/" + subreddit + "/top/" : "/top/" }, { Link: Link }),
        "top"
      ),
      _react2.default.createElement(
        NavTab,
        _extends({ href: subreddit ? "/" + siteprefix + "/" + subreddit + "/gilded/" : "/gilded/" }, { Link: Link }),
        "gilded"
      )
    )
  );
};

exports.default = HeaderBottomLeft;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/HeaderBottomLeft.js
// module id = 315
// module chunks = 0